import { render, staticRenderFns } from "./test.vue?vue&type=template&id=4c2ff01d&scoped=true&"
import script from "./test.vue?vue&type=script&lang=js&"
export * from "./test.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adminTweetList.css?vue&type=style&index=0&id=4c2ff01d&lang=css&scoped=true&"
import style1 from "./test.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ff01d",
  null
  
)

export default component.exports